import {Component, OnInit} from '@angular/core';
import {HcaMemberService} from '../../../../../../shared/_services/hca-member.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {StatusModalComponent} from '../../../../../modals/status-modal/status-modal.component';
import {Subject} from 'rxjs/Subject';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-members-booking',
  templateUrl: './members-booking.component.html',
  styleUrls: ['./members-booking.component.scss']
})
export class MembersBookingComponent implements OnInit {
  memberSubscription: Subscription;
  memberInfo: any;
  totalCount: number;
  p = 0;
  size = 10;
  memberId: number | string;
  statusModal: BsModalRef;
  bookingList: any[] = [];
  private unsubscribe: Subject<void> = new Subject<void>();
  destroySubscription$: Subject<boolean> = new Subject();

  constructor(
    private modalService: BsModalService,
    private hcaMemberService: HcaMemberService
  ) {
    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(() => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.action === 'action1') {
          if (this.statusModal.content.srcObject.type === 'booking-list') {
            if (this.statusModal.content.srcObject.status) {
              let statusId: any;
              if (this.statusModal.content.srcObject.status === 'Activate') {
                statusId = 1; // 'Active'
              } else {
                statusId = 0; // 'Inactive'
              }
              this.hcaMemberService.activateOrDeactivateBooking(this.statusModal.content.srcObject.id, statusId).subscribe(
                res => {
                  if (res.error === 0) {
                    this.getBookingData();
                  }
                }, error => {
                  console.error(error);
                });
            }
          }
        }
      }
    });
  }

  updateBadgeStatus(memberId, type) {
    this.hcaMemberService.updateBadgeEvents(memberId, type).subscribe(res => {
      if (res.error === 0) {
        this.memberInfo = res.responseObj;
        this.hcaMemberService.setMember(this.memberInfo);
      }
    }, err => {
      console.error('Error while updating member issue status by Id: ', err.message);
    });
  }

  getBookingData(pageNum?) {
    this.p = pageNum ? pageNum : this.p;
    this.hcaMemberService.getBookingData(this.p > 0 ? this.p - 1 : this.p, this.memberId).subscribe(res => {
      if (res.error === 0) {
        this.bookingList = res.responseObj && res.responseObj.bookingTos && res.responseObj.bookingTos.length
          ? res.responseObj.bookingTos : [];
        this.totalCount = res.responseObj && res.responseObj.totalRecords ? res.responseObj.totalRecords : 0;
      }
    });
    if (this.memberInfo && this.memberInfo.bookingEscalation) {
      this.updateBadgeStatus(this.memberId, 'bookingEscalation');
    }
  }


  openModalActivateDeactivate(id, mode) {
    this.statusModal = this.modalService.show(StatusModalComponent, {class: 'confirm-modal'});
    let message = '';
    let title = '';
    let action1 = '';
    let style = '';
    let status = '';
    if (mode === 'Active') {
      message = 'Are you sure you want to deactivate booking?';
      title = 'Deactivate Booking';
      action1 = 'Deactivate';
      style = 'inactive';
      status = 'Inactive';
    } else if (mode === 'Inactive') {
      message = 'Are you sure you want to activate booking?';
      title = 'Activate Booking';
      action1 = 'Activate';
      style = 'active';
      status = 'Activate';
    }
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'booking-list',
      title: title,
      message: message,
      status,
      id: id,
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style,
    };
  }

  ngOnInit() {
    this.memberId = this.hcaMemberService.getMemberId;
    this.memberInfo = this.hcaMemberService.getMemberInfo;
    this.getBookingData();
    this.memberSubscription = this.hcaMemberService.memberData$
      .takeUntil(this.destroySubscription$)
      .subscribe((state: any) => {
        if (state) {
          this.memberInfo = state;
          if (this.memberInfo && this.memberInfo.bookingEscalation) {
            this.updateBadgeStatus(this.memberId, 'bookingEscalation');
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/reception/members-management/members-booking/members-booking.component.ts